import AddCardModal from "./AddCardModal";
import CardModal from "./CardModal";
import DeleteDeckModal from "./DeleteDeckModal";
import DeleteCardModal from "./DeleteCardModal";
import DeleteUserModal from "./DeleteUserModal";
import EditDeckModal from "./EditDeckModal";
import EditCardModal from "./EditCardModal";
import ImportCardsModal from "./ImportCardsModal";
import ResetCardModal from "./ResetCardModal";
import ResetDeckModal from "./ResetDeckModal";

export const MODAL_TYPES = {
  ADD_ITEM: "addItem",
  CARD_ITEM: "cardItem",
  DELETE_DECK: "deleteDeck",
  DELETE_ITEM: "deleteItem",
  DELETE_USER: "deleteUser",
  EDIT_DECK: "editDeck",
  EDIT_ITEM: "editItem",
  IMPORT_ITEMS: "importItems",
  RESET_DECK: "resetDeck",
  RESET_ITEM: "resetItem",
};

export {
  AddCardModal,
  CardModal,
  DeleteDeckModal,
  DeleteCardModal,
  DeleteUserModal,
  EditDeckModal,
  EditCardModal,
  ImportCardsModal,
  ResetDeckModal,
  ResetCardModal,
};



// WEBPACK FOOTER //
// ./src/components/modals/index.js